<script setup lang="ts">
import { usePlaceStore } from "@/modules/place-module";
import { computed } from "vue";
import PlaceWorkTime from "./PlaceWorkTime.vue";
import PlaceAddress from "./PlaceAddress.vue";
import PlaceContacts from "./PlaceContacts.vue";
import PlaceConditions from "./PlaceConditions.vue";
import PlaceReviewsPreview from "./PlaceReviewsPreview.vue";
import PlacePaymentsMethods from "./PlacePaymentsMethods.vue";

const emit = defineEmits(["showReviews", "ratePlace"]);
const placeStore = usePlaceStore();
const place = computed(() => placeStore.place);
</script>

<template>
  <div class="place-details">
    <PlaceWorkTime />

    <PlaceConditions v-if="place?.place.flags.length" />

    <PlacePaymentsMethods
      v-if="place?.place.payment_methods.length && place?.products.length"
    />

    <PlaceAddress v-if="!place?.place.badges.includes('online')" />

    <PlaceContacts v-if="place?.place.contacts.length" />
  </div>

  <PlaceReviewsPreview
    v-if="!place?.reviews.length"
    @showReviews="emit('showReviews')"
    @ratePlace="emit('ratePlace', $event)"
  />
</template>

<style scoped lang="scss">
.place-details {
  padding: calc($base-space * 6) ($base-space * 8);
  display: grid;
  grid-template-columns: 1fr;
  gap: calc($base-space * 6);

  @media (max-width: 1023px) {
    padding: calc($base-space * 6);
  }

  @media (max-width: 767px) {
    padding: calc($base-space * 5) ($base-space * 4);
    gap: calc($base-space * 5);
  }
}
</style>
